import React from 'react'
import styles from './index.module.scss'

import cmThumbnailWorkation from '../../public/cm_section_thumbnail_workation.png'
import cmThumbnailOshikatsu from '../../public/cm_section_thumbnail_oshikatsu.png'
import cmSectionLabel from '../../public/cm_section_label.png'
import { VideoPlayer } from '../VideoPlayer'

type CmSectionMovieProps = {
  isPc?: boolean
}

const CmSectionMovie = ({ isPc }: CmSectionMovieProps) => {
  return (
    <section className={styles.container}>
      <img
        src={cmSectionLabel.src}
        alt="CM Section Label"
        className={styles.label}
      />
      <h2 className={styles.text}>
        あなたは
        <br />
        どんな働き方を叶えたい？
      </h2>
      {isPc ? (
        <div className={styles.videoContainer}>
          <VideoPlayer
            title="推し活CM"
            thumbnail={cmThumbnailOshikatsu.src}
            src="https://player.vimeo.com/video/1105753456"
            videoID="cmSection"
          />
          <VideoPlayer
            title="ワーケーションCM"
            thumbnail={cmThumbnailWorkation.src}
            src="https://player.vimeo.com/video/1105753425"
            videoID="cmSection"
          />
        </div>
      ) : (
        <VideoPlayer
          title="ワーケーションCM"
          thumbnail={cmThumbnailWorkation.src}
          src="https://player.vimeo.com/video/1105753425"
          videoID="cmSection"
        />
      )}
    </section>
  )
}

export default CmSectionMovie
